<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else>
    <div class="">
      <Navbar
        id="header"
        class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
      >
        <template v-slot:left>
          <div id="name" class="flex flex-row">
            <router-link
              :to="{ name: 'survey-list' }"
              class="px-4 text-lg font-bold border border-transparent cursor-pointer rounded text-purple-600 hover:no-underline"
              >AppFlowz
            </router-link>
          </div>
        </template>
      </Navbar>

      <div class="px-4 md:px-10 mt-5 mx-auto w-full ">
        <div v-if="dataset.length === 0">No responses found.</div>
        <div v-else class="flex flex-col justify-center" v-cloak>
          <router-link
            :to="{ path: '/surveys/list' }"
            class="px-4 font-normal align-middle text-sm border border-transparent cursor-pointer rounded text-gray-400 hover:no-underline hover:text-purple-400"
          >
            <svg-icon
              icon="heroicons/outline/arrow-left"
              class="h-4 w-4 inline-block align-middle"
            ></svg-icon>
            Back to surveys
          </router-link>

          <!--Search Bar
              <div class="flex flex-row-reverse mt-20 mb-5">
                <input
                  placeholder="Search..."
                  class="rounded bg-white border border-solid border-gray-300 hover:border-gray-400 px-2 text-sm ml-2 outline-none focus:outline-none focus:ring focus:border-purple-500"
                />
              </div>
-->

          <div class="overflow-x-auto mt-10">
            <div class=" py-2 align-middle inline-block min-w-full">
              <div id="user-card" class="">
                <table
                  class="table-fixed max-w-lg divide-y divide-gray-200 bg-white shadow"
                >
                  <thead class="bg-purple-100">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-800 uppercase"
                      ></th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-800 uppercase"
                      ></th>
                      <th
                        v-for="(step, index) in steps"
                        :key="index"
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-800 uppercase whitespace-nowrap"
                      >
                        {{ crop(step.title) }}
                      </th>

                      <th scope="col" class="relative px-6 py-3">
                        <span class="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>

                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(visitor, index) in dataset" :key="index">
                      <td class="py-2">
                        <div class="flex flex-row justify-center items-center">
                          <router-link
                            :to="{
                              path: `/result/${survey.id}/visitor/${visitor.id}`,
                            }"
                          >
                            <svg-icon
                              icon="heroicons/solid/eye"
                              class="h-6 w-6 cursor-pointer text-purple-500"
                              v-tooltip="'View responses'"
                            />
                          </router-link>
                        </div>
                      </td>
                      <td class="px-6 py-2">
                        <div class="flex items-center">
                          <div class="flex-shrink-0 h-10 w-10">
                            <img
                              class="h-10 w-10 rounded-full"
                              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330"
                              alt=""
                              style="object-fit: cover"
                            />
                          </div>
                          <div class="ml-4">
                            <div class="text-sm font-medium text-gray-900">
                              {{ visitor.name }}
                            </div>
                            <div class="text-sm text-gray-500">
                              {{ visitor.email }}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td
                        v-for="(step, index) in steps"
                        :key="index"
                        class="px-6 text-sm text-gray-500"
                        v-text="getResult(visitor, step.id)"
                      ></td>
                    </tr>
                  </tbody>
                </table>

                <!-- Pagination
                <div
                  class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
                >
                  <div class="flex-1 flex justify-between sm:hidden">
                    <a
                      href="#"
                      class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
                    >
                      Previous
                    </a>
                    <a
                      href="#"
                      class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
                    >
                      Next
                    </a>
                  </div>
                  <div
                    class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
                  >
                    <div>
                      <p class="text-sm text-gray-700">
                        Showing
                        <span class="font-medium">1</span>
                        to
                        <span class="font-medium">10</span>
                        of
                        <span class="font-medium">97</span>
                        results
                      </p>
                    </div>
                    <div>
                      <nav
                        class="relative z-0 inline-flex shadow-sm -space-x-px"
                        aria-label="Pagination"
                      >
                        <a
                          href="#"
                          class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                        >
                          <span class="sr-only">Previous</span>
                         
                          <svg-icon
                            icon="heroicons/solid/chevron-left"
                            class="h-5 w-5"
                          />
                        </a>
                        <a
                          href="#"
                          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          1
                        </a>
                        <a
                          href="#"
                          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          2
                        </a>
                        <a
                          href="#"
                          class="hidden md:inline-flex relative items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          3
                        </a>
                        <span
                          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
                        >
                          ...
                        </span>
                        <a
                          href="#"
                          class="hidden md:inline-flex relative items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          8
                        </a>
                        <a
                          href="#"
                          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          9
                        </a>
                        <a
                          href="#"
                          class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                          10
                        </a>
                        <a
                          href="#"
                          class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                        >
                          <span class="sr-only">Next</span>
                          
                          <svg-icon
                            icon="heroicons/solid/chevron-right"
                            class="h-5 w-5"
                          />
                        </a>
                      </nav>
                    </div>
                  </div>
                </div> -->
              </div>
              <!--End User Card-->
            </div>
          </div>

          <button
            @click="saveCSV()"
            class="max-w-xs mt-5 px-2 py-2 mt-2 block bg-purple-500 hover:bg-purple-400 text-white active:bg-indigo-600 font-bold uppercase text-xs rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
            type="button"
            style="transition: all .15s ease"
          >
            <span v-if="downloading" class="spinner mx-11"></span>
            <span v-else class="mx-4 my-3">Download All Responses</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Header";
//import SidebarComponent from "@/components/CreativeTim/Sidebar.vue";
import Survey from "@/models/Survey";
import router from "@/router/route.js";
import axios from "axios";

export default {
  name: "results-page",
  components: {
    Navbar,
    //SidebarComponent,
  },
  data() {
    return {
      loading: false,
      downloading: false,
      dataset: [{}, {}],
    };
  },
  props: ["surveyid"],
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("steps", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    steps() {
      //filter out welcome step or thank you step
      return this.survey.steps.filter(
        (step) => step.type != "end" && step.type != "welcome"
      );
    },
  },
  methods: {
    async init() {
      var id = this.surveyid || null;

      if (id === null) {
        console.log("Error, survey not found.");
        router.push({ name: "survey-list" });
      }

      this.loading = true;

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      }
      this.loadResponses();

      this.loading = false;
    },
    /*
    getCsv() {
      let url =
        "http://tailapp.test/laravel/public/api/response/export-csv/" +
        this.survey.id;
      window.location.href = url;
    },
    */
    async saveCSV() {
      this.downloading = true;
      var url =
        axios.defaults.baseURL + "api/response/export-csv/" + this.survey.id;

      axios({
        url: "/api/response/export-csv/" + this.survey.id,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "responses.csv");
        document.body.appendChild(link);
        link.click();

        this.downloading = false;
      });

      /*

      var xhr = new XMLHttpRequest();

      await new Promise(function(resolve, reject) {
        xhr.responseType = "blob";
        xhr.onload = function() {
          resolve(xhr);
        };
        xhr.onerror = reject;
        xhr.open("GET", url);
        xhr.send();
      });

      var filename = "export.csv"; // url.substring(url.lastIndexOf("/") + 1).split("?")[0];
      var a = document.createElement("a");
      a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
      a.download = filename; // Set the file name.
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();

      this.downloading = false;
      return xhr;
    */
    },
    getResult(visitor, stepid) {
      if (typeof visitor.results !== "undefined")
        return visitor.results[stepid];
      else return null;
    },
    loadResponses() {
      //load survey responses into this.dataset
      axios
        .get("/api/response/survey/" + this.survey.id)
        .then((response) => {
          console.log("answers: " + response.data.data);
          this.dataset = response.data.data;
        })
        //if user request fails
        .catch(() => {
          //
        });
    },
    crop(str) {
      if (str.length > 20) str = str.substring(0, 17) + "...";
      return str;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
[v-cloak] {
  display: none;
}
</style>
